import React from 'react';
import { compose, lifecycle, withState, withProps, withHandlers } from 'recompose';
import { withRouter } from 'react-router-dom';
import { users } from './_api';
import withLoader from '../app/withLoader';
import Paper from '@material-ui/core/Paper';
import { connect } from 'react-redux';
import { Grid, Table, TableHeaderRow, TableFilterRow } from '@devexpress/dx-react-grid-material-ui';
import {
  SortingState,
  IntegratedSorting,
  FilteringState,
  IntegratedFiltering,
} from '@devexpress/dx-react-grid';
import { withSnackbar } from 'notistack';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

const collator = new Intl.Collator('cs');
const comparePriority = (a, b) => {
  return collator.compare(a, b);
};

const enhance = compose(
  withState('items', 'setItems', []),
  withRouter,
  withLoader,
  withSnackbar,
  withHandlers({
    loadItems:
      ({ toggleLoader, setItems }) =>
      async () => {
        toggleLoader();
        const resp = await users(false);
        if (resp) {
          setItems(get(resp, 'items', []));
        }
        toggleLoader(false);
      },
  }),
  lifecycle({
    async componentDidMount() {
      const { loadItems } = this.props;
      await loadItems();
    },
    async componentWillReceiveProps(nextProps) {
      const { loadItems } = this.props;
      if (this.props.reload !== nextProps.reload) {
        await loadItems();
      }
    },
  }),
  connect(
    (state) => ({
      isMiniMode: get(state, 'app.miniMode', false),
    }),
    null
  ),
  withProps(({ setDialog, isMiniMode }) => ({
    columns: [
      { name: 'username', title: 'Login' },
      {
        name: 'name',
        title: 'Jméno',
        getCellValue: (row) => `${get(row, 'surname') || ''} ${get(row, 'forename') || ''}`,
      },
      { name: 'phone', title: 'Telefon' },
      { name: 'email', title: 'Email' },
      { name: 'userGroup', title: 'Stupeň registrace' },
      {
        name: 'delete',
        title: ' ',
        getCellValue: (row) => (
          <div>
            <Button
              variant="outlined"
              size={isMiniMode ? 'small' : 'medium'}
              onClick={(e) => {
                e.stopPropagation();
                setDialog({ open: true, id: row.id, action: 'user-delete' });
              }}
            >
              Smazat
            </Button>
          </div>
        ),
      },
    ],
  })),
  withHandlers({
    redirectTo:
      ({ history }) =>
      async (id) => {
        history.push(`/users/${id}`);
      },
  }),
  withHandlers({
    TableRow:
      ({ redirectTo, isMiniMode }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              cursor: 'pointer',
              ...(isMiniMode ? { height: 'auto' } : {}),
            }}
            onClick={() => redirectTo(get(row, 'id'))}
          />
        ),
    TableHeaderRowCustom:
      ({ isMiniMode }) =>
      (props) =>
        (
          <Table.Row
            {...props}
            style={{
              ...(isMiniMode ? { height: 'auto' } : {}),
            }}
          />
        ),
  })
);

export default enhance(
  ({
    dialog,
    items,
    columns,
    setDialog,
    deleteUser,
    TableRow,
    TableHeaderRowCustom,
    isMiniMode,
  }) => (
    <div style={{ margin: 10 }}>
      <Button
        variant="contained"
        color="primary"
        component={(props) => <Link to="/users/add" {...props} />}
        style={{ marginBottom: isMiniMode ? 5 : 20 }}
        size={isMiniMode ? 'small' : 'medium'}
      >
        Přidat
      </Button>
      <Paper>
        <div className="grid--clickable grid--custom">
          <Grid rows={items} columns={columns}>
            <SortingState defaultSorting={[{ columnName: 'name', direction: 'asc' }]} />
            <FilteringState defaultFilters={[]} />
            <IntegratedSorting
              columnExtensions={[{ columnName: 'name', compare: comparePriority }]}
            />
            <IntegratedFiltering />
            <Table rowComponent={TableRow} />
            <TableHeaderRow showSortingControls rowComponent={TableHeaderRowCustom} />
            <TableFilterRow rowComponent={TableHeaderRowCustom} />
          </Grid>
        </div>
      </Paper>
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/users/index.js